import '@xsolla/metrika';

import React, { useCallback, useEffect, useState } from 'react';
import { InitXAParams, XsollaAnalytics } from '@/types/xsollaAnalytics';

const XADefaultValue = {
  hit(): void {
    throw new Error('Function not implemented.');
  },
  externalLink(): void {
    throw new Error('Function not implemented.');
  },
  elementClick(): void {
    throw new Error('Function not implemented.');
  },
  formData(): void {
    throw new Error('Function not implemented.');
  },
  customEvent(): void {
    throw new Error('Function not implemented.');
  },
};

const siteDomains = ['x.la', 'x.la/drops', 'x.la/rewards'];

const counterId = Number(process.env.NEXT_PUBLIC_XSOLLA_METRIKA_COUTER_ID);

export const XAContext = React.createContext<XsollaAnalytics>(XADefaultValue);

export default function XAProvider({ children }: React.PropsWithChildren): React.ReactElement {
  const [XA, setXA] = useState<XsollaAnalytics>(XADefaultValue);

  const initAnalytics = useCallback(async () => {
    try {
      // XA analytics
      const initXAOptions: InitXAParams = {
        id: counterId,
        server: 'https://datagather.xsolla.com/hit',
        siteDomains,
        hit: true,
        extLink: true,
        click: true,
        scroll: true,
      };

      window.XA = new window.XsollaAnalytics(initXAOptions);

      const { hit } = window.XA;

      window.XA.hit = (url, options = {}) => {
        const newOptions = options ? { ...options } : {};

        if (options.exv) {
          newOptions.exv = { ...options.exv };
        }

        hit(url, newOptions);
      };

      // add return stmt here just to follow eslint rule (consistent return)
      return setXA(window.XA);
    } catch (e) {
      return e;
    }
  }, []);

  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <XAContext.Provider value={XA}>
      {children}
    </XAContext.Provider>
  );
}
